import React from 'react';
import { Field, Form, Formik, FormikHelpers } from 'formik';
import { range } from 'lodash';

import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import MenuItem from '@material-ui/core/MenuItem';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import DialogPaper from '../DialogPaper';

// import * as StampCardService from '../../api/stampCardService';
import TextField from '../FormikAdapter/TextField';
import useCompanyContext from '../../hooks/useCompanyContext';

export interface Values {
  removeStampNum: string;
}

const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    width: 150,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    width: '100%',
  },
  title: {
    marginTop: theme.spacing(3),
    fontWeight: theme.typography.fontWeightBold,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  subtext: {
    marginTop: theme.spacing(2),
    textAlign: 'center',
    fontSize: 16,
  },
  avatar: {
    height: 80,
    width: 80,
    boxShadow: '0 2px 10px rgba(199, 199, 199, 0.5)',
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(3),
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  grow: {
    flexGrow: 1,
  },
  menuItem: {
    fontSize: 30,
  },
}));

type Props = Pick<DialogProps, 'open' | 'onClose'> & {
  confirmRemove: (removeStamp: number) => void;
  currentStamps: number;
};

export default function RemoveStampDialog({
  onClose,
  open,
  confirmRemove,
  currentStamps,
}: Props) {
  const { company } = useCompanyContext();
  const classes = useStyles();

  const initialValues: Values = {
    removeStampNum: '1',
  };

  const TOTAL_STAMPS_MENU_ITEMS =
    currentStamps === 1
      ? [
          {
            value: 1,
            label: '1',
          },
        ]
      : range(1, currentStamps + 1).map((i) => ({
          value: i,
          label: i.toString(),
        }));

  const handleSubmit = async (values: Values, _: FormikHelpers<Values>) => {
    try {
      if (company) {
        confirmRemove(parseInt(values.removeStampNum, 10));
        // let stampAdded = parseInt(values.stampNum, 10);
        // await StampCardService.credit({
        //   companyId: company.id,
        //   stampCardId,
        //   numOfStamps: stampAdded,
        //   pin,
        // });
        // confirmRedeem(stampAdded);
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={DialogPaper}>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={false}
      >
        {({ isSubmitting, values: { removeStampNum } }) => {
          return (
            <Form noValidate autoComplete="off">
              <div className={classes.cardContainer}>
                <Typography variant="h6" className={classes.title} gutterBottom>
                  Number of Stamps to Remove
                </Typography>
                <Field
                  component={TextField}
                  name="removeStampNum"
                  label=""
                  autoFocus
                  fullWidth
                  required
                  select
                >
                  {TOTAL_STAMPS_MENU_ITEMS.map((cost, idx) => (
                    <MenuItem
                      value={cost.value}
                      key={idx}
                      className={classes.menuItem}
                    >
                      {cost.label}
                    </MenuItem>
                  ))}
                </Field>
                <Typography className={classes.subtext} gutterBottom>
                  {`REMOVE ${removeStampNum} STAMP${
                    parseInt(removeStampNum, 10) > 1 ? 'S' : ''
                  }`}
                </Typography>
                <Button
                  type="submit"
                  color="primary"
                  className={classes.buttonContainer}
                  disabled={isSubmitting}
                >
                  CONFIRM
                </Button>
              </div>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
}
